@if ((currentCustomProvisioningData$ | async) === undefined) {
  <section class="breadcrumb-section">
    <ra-fthub-breadcrumb
      id="ra-ui-portal-breadcrumb"
      [items]="(breadcrumbs$ | async) || []"
      [autoHideTitle]="true"
      (itemClicked)="onClicked($event)"
      [title]="(title$ | async) || ''"
    >
    </ra-fthub-breadcrumb>

    <ng-template #iconTemplate>
      <i class="navigation-separator-style ra-icon-ide-sm-caret-right"></i>
    </ng-template>
  </section>
}

@if (navigateSignal$ | async) {}
